import React, { useMemo } from "react";
import { Col, Form, Input, Row } from "antd";
import MaskedInput from "antd-mask-input";
import { FormItemInputId } from "../../common";
import "./SearchFiltersIndividual.less";
import usePhoneMask from "../../../lib/hooks/usePhoneMask";
import { shortNames } from "../../../lib/const/shortsNames";

export const SearchFiltersIndividual = () => {
  const { phoneMask } = usePhoneMask();

  return (
    <div className="search-filters-individual">
      <Row gutter={50}>
        <Col span={12}>
          <Form.Item
            label="ФИО"
            name="individual.fullName"
            className="search-filters-individual__formItem"
          >
            <Input placeholder="Введите ФИО" allowClear />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Номер договора"
            name="agreementNumber"
            className="search-filters-individual__formItem"
          >
            <Input placeholder="Введите номер договора" allowClear />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Контактный телефон"
            name="individual.phone"
            className="search-filters-individual__formItem"
          >
            <MaskedInput mask={phoneMask.full} name="phone" allowClear />
          </Form.Item>
        </Col>
        <Col span={12}>
          <FormItemInputId
            label="ID договоров"
            name="agreementIds"
            placeholder={`Введите ID договоров через ","`}
            className="search-filters-individual__formItem"
            allowClear
          />
        </Col>
        <Col span={12}>
          <Form.Item
            label={shortNames.externalId}
            name="subscriber.externalId"
            className="search-filters-individual__formItem"
          >
            <Input placeholder="Введите Тех. ID аккаунта" allowClear />
          </Form.Item>
        </Col>
        <Col span={12}>
          <FormItemInputId
            label="ID аккаунтов"
            name="accountIds"
            placeholder={`Введите ID аккаунтов через ","`}
            className="search-filters-individual__formItem"
            allowClear
          />
        </Col>
      </Row>
    </div>
  );
};
